import Module from '@/store/resource/common/module';
import Views from '@/store/resource/views';
import api from '@/factories/api';
import isEmpty from 'lodash/isEmpty';

let module = new Module(new Views());

module.add('state', {
  contactCounts: {},
});

module.add('getters', {
  contactCount(state) {
    return (viewId) => {
      if (!viewId || !(viewId in state.contactCounts)) return undefined;
      return state.contactCounts[viewId];
    };
  },

  byTeam(state) {
    return (teamId) => {
      if (!teamId) return state.all;
      return state.all.filter((view) => {
        return (
          !view.teams || view.teams.length === 0 || view.teams.includes(teamId)
        );
      });
    };
  },

  byLayout(state) {
    return (layout) => {
      return state.all.filter((view) => view.layout === layout);
    };
  },

  sorted(state) {
    return [...state.all].sort((a, b) => {
      return (a.order || 0) - (b.order || 0);
    });
  },
});

module.add('mutations', {
  setContactCount(state, { viewId, count }) {
    state.contactCounts = { ...state.contactCounts, [viewId]: count };
  },

  invalidateContactCount(state, viewId) {
    const { [viewId]: _, ...rest } = state.contactCounts;
    state.contactCounts = rest;
  },
});

module.add('actions', {
  async loadContactCount({ commit, state }, view) {
    if (!view || !view.id) return;
    if (view.id in state.contactCounts) return;

    const filters = view.filters;
    const params = { format: 'v2', page: 1 };

    if (filters && !isEmpty(filters)) {
      params.filters = filters;
    }

    try {
      const res = await api().get('contacts', { params });
      const count = res?.count || (res?.results || []).length;
      commit('setContactCount', { viewId: view.id, count });
    } catch (err) {
      commit('setContactCount', { viewId: view.id, count: 0 });
    }
  },
});

export default module.create();
